import styles from './TemplateCardSkeleton.module.css';

export interface TemplateCardSkeletonCellProps {
  className?: string;
  /** true：宽高 100% 铺满父级（如封面未就绪时叠在卡片内） */
  fitContainer?: boolean;
}

/** 模板卡片骨架单格：扫光样式全部在 {@link TemplateCardSkeleton.module.css} */
export function TemplateCardSkeletonCell({
  className = '',
  fitContainer = false,
}: TemplateCardSkeletonCellProps) {
  return (
    <div
      className={[styles.cell, fitContainer && styles.cellFit, className]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
